<template>
    <div class="row">
        <div class="col-md-5">
            <div class="row">
                <div class="col-md-12">
                    <servicio-presupuesto-datos-descripcion :seleccionado="seleccionado" :id="id"/>          
                </div>
                <div class="col-md-12">
                    <servicio-presupuesto-datos-condiciones :seleccionado="seleccionado"  :id="id"/>
                </div>
                <div class="col-md-12">
                    <servicio-presupuesto-datos-perito :seleccionado="seleccionado" :id="id" />
                </div>
            </div>
        </div>
        <div class="col-md-7">
            <div class="row">
                <div class="col-md-12">
                    <servicio-presupuesto-datos-operarios @actualizar="actualizar" :seleccionado="seleccionado" :id="id" />
                </div>
                <div class="col-md-12">
                    <servicio-presupuesto-datos-fotos @actualizar="actualizar" @marcar="marcar" :seleccionado="seleccionado" :id="id" />
                </div>
                <div class="col-md-12">
                    <servicio-presupuesto-datos-generados ref="generados" @enviado="enviado" :servicio="servicio" @actualizar="actualizar" :seleccionado="seleccionado" :id="id"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import serviciopresupuestodatosdescripcion from './presupuesto_descripcion.vue'; 
import serviciopresupuestodatoscondiciones from './presupuesto_condiciones.vue';
import serviciopresupuestodatosperito from './presupuesto_perito.vue';
import serviciopresupuestodatosoperarios from './presupuesto_operarios.vue';
import serviciopresupuestodatosgenerados from './presupuesto_generados.vue';
import serviciopresupuestodatosfotos from './presupuesto_fotos.vue';


export default ({
    props: ['id', 'seleccionado', 'servicio'],


    data() {
        return {
        }},
    components: {
        'servicio-presupuesto-datos-descripcion': serviciopresupuestodatosdescripcion,
        'servicio-presupuesto-datos-condiciones': serviciopresupuestodatoscondiciones,
        'servicio-presupuesto-datos-perito': serviciopresupuestodatosperito,
        'servicio-presupuesto-datos-generados': serviciopresupuestodatosgenerados,
        'servicio-presupuesto-datos-operarios': serviciopresupuestodatosoperarios,
        'servicio-presupuesto-datos-fotos': serviciopresupuestodatosfotos,
    },
    methods: {
        marcar(marcados,idsmarcados){
            this.$refs.generados.marcar(marcados,idsmarcados);
        },
        actualizar(){
            this.$emit('actualizar');
        },
        enviado() {
            this.$emit('enviado');
        }
    },
 
    watch: {
        
    }
})
</script>